'use client';

import { useQuery } from '@tanstack/react-query';

import { PlayerGear } from '@/modules/players/v3/types';
import { getPlayerGear } from '@/utils/actions/players/edit/gear/getPlayerGear';

export const useGetPlayerGear = (
  playerUuid: string,
  initialPlayerGear: PlayerGear[],
  queryKey: string
) => {
  return useQuery<PlayerGear[], Error>({
    queryKey: [queryKey, playerUuid],
    queryFn: async () => {
      const res = await getPlayerGear({ playerUuid });
      if (res.error) {
        throw new Error(`Failed to get player gear: ${res.error}`);
      }
      return res.data?.gear ?? [];
    },
    initialData: initialPlayerGear,
  });
};
